var React = require('react');

function DeleteCircle (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")),React.createElement("circle",{"className":"a","cx":"11.998","cy":"12","r":"11.25","key":1}),React.createElement("line",{"className":"a","x1":"7.498","y1":"16.5","x2":"16.497","y2":"7.5","key":2}),React.createElement("line",{"className":"a","x1":"16.498","y1":"16.5","x2":"7.497","y2":"7.5","key":3})]);
}

DeleteCircle.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = DeleteCircle;

DeleteCircle.default = DeleteCircle;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svgs/delete-circle.svg
// module id = 1068
// module chunks = 0